import { render, staticRenderFns } from "./OnboardingDecoration.vue?vue&type=template&id=74c2c682&scoped=true"
import script from "./OnboardingDecoration.vue?vue&type=script&lang=ts"
export * from "./OnboardingDecoration.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingDecoration.vue?vue&type=style&index=0&id=74c2c682&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c2c682",
  null
  
)

export default component.exports